export const overlayScrimClass =
  'surface-overlay fixed inset-0 z-[8500] flex items-center justify-center p-3 sm:p-4 text-white';

export const overlayScrimModalClass =
  'surface-overlay fixed inset-0 z-[9000] flex items-center justify-center p-3 sm:p-4 text-white';

export const overlayCardClass = 'surface-card relative flex w-full flex-col overflow-hidden';

export const overlayCardSizes = {
  lg: 'max-w-2xl',
  xl: 'max-w-5xl w-[min(94vw,64rem)] max-h-[88vh]',
  patientDetail: 'max-w-[min(96vw,82rem)] w-full h-[90vh] max-h-[90vh]',
  full: 'max-w-[94vw] w-full max-h-[90vh]',
} as const;
